import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSkeleton } from '@/components/common/LoadingSkeleton';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Guards any route that requires an authenticated session.
 *
 * Behaviour:
 * - While auth is resolving: renders a full-page skeleton (prevents flash of
 *   the login page before the Supabase session is hydrated from localStorage).
 * - Unauthenticated: redirects to /auth.
 * - Authenticated with profile: renders children.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { profile, isLoading } = useAuth();

  if (isLoading) {
    // Full-page skeleton prevents content flash while Supabase hydrates.
    return <LoadingSkeleton fullPage />;
  }

  if (!profile) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}
